<template>
  <v-row>
    <v-col cols="6" md="3">
      <DashCard
        :history="history"
        :prop="current.TempIn"
        title="Inside"
        icon="fas fa-temperature-high"
        suffix="°C"
        :min="min"
        :max="max"
      />
    </v-col>
    <v-col cols="6" md="3">
      <DashCard
        :history="history"
        :prop="current.TempOut"
        title="Outside"
        icon="fas fa-temperature-high"
        suffix="°C"
        :min="min"
        :max="max"
      />
    </v-col>
    <v-col cols="6" md="3">
      <DashCard
        :history="history"
        :prop="current.Humidity"
        title="Humidity"
        icon="fas fa-tint"
        suffix="%"
        min="58"
        max="70"
      />
    </v-col>
    <v-col cols="6" md="3">
      <DashCard
        :history="history"
        :prop="current.Pressure"
        title="Pressure"
        icon="fas fa-weight"
        suffix="hPa"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
import DashCard from "@/components/DashCard";

export default {
  name: "Dashboard",
  components: {
    DashCard,
  },
  data() {
    return {
      window: 0,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      preferences: (state) => state.auth.preferences,
      current: (state) => state.mill.current,
      history: (state) => state.mill.history,
    }),

    min() {
      if (!this.user) {
        return "26";
      } else {
        return this.preferences.tempInMin;
      }
    },

    max() {
      if (!this.user) {
        return "28";
      } else {
        return this.preferences.tempInMax;
      }
    },
  },
  mounted() {
    this.$store.dispatch("fetchCurrent");
    this.$store.dispatch("fetchHistory");
  },
};
</script>

<style scoped>
.is-green {
  background: #90be6d;
  /* background: -webkit-linear-gradient(to bottom, #fff, #80b918);
  background: linear-gradient(to bottom, #fff, #80b918); */
}

.is-orange {
  background: #f8961e;
  /* background: -webkit-linear-gradient(to bottom, #fff, #f48c06);
  background: linear-gradient(to bottom, #fff, #f48c06); */
}

.is-red {
  background: #f4645a;
  /* background: -webkit-linear-gradient(to bottom, #fff, #d00000);
  background: linear-gradient(to bottom, #fff, #d00000); */
}

.is-purple {
  background: #9d4edd;
  /* background: -webkit-linear-gradient(to top left, #fff, #c989eb, #9d4edd);
  background: linear-gradient(to top left, #fff, #c989eb, #9d4edd); */
}
</style>
